<template>
  <div class="jikangai-notes edit-item" v-if="editingData">

    <div class="head"><b>時間外手当の考え</b></div>
    <div class="data">
      <input-textarea v-model="editingData.jikangai_notes"
        :error="getError(editingData, 'jikangai_notes')" :disabled="disabled"></input-textarea>
      <p class="current-data pre" v-if="currentData?.jikangai_notes">{{ currentData.jikangai_notes }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
